/**
 * Formatea un número como moneda.
 * Separador de miles: ,
 * Separador decimal: .
 * Símbolos: USD = $, NIO = C$
 */
export type Moneda = 'USD' | 'NIO';

const SIMBOLOS: Record<Moneda, string> = {
  USD: '$',
  NIO: 'C$',
};

/** Solo número con miles y 2 decimales (sin símbolo). Ej: 1,234.50 */
export function formatAmount(value: number | undefined | null): string {
  const n = Number(value);
  if (Number.isNaN(n)) return '0.00';
  const fixed = Math.abs(n).toFixed(2);
  const [entera, decimal] = fixed.split('.');
  const conMiles = entera.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const signo = n < 0 ? '-' : '';
  return `${signo}${conMiles}.${decimal}`;
}

export function formatCurrency(
  value: number | undefined | null,
  moneda: Moneda = 'USD'
): string {
  const n = Number(value);
  if (Number.isNaN(n)) return `${SIMBOLOS[moneda]}0.00`;
  const signo = n < 0 ? '-' : '';
  // formatAmount ya incluye signo; evitar duplicar
  const absFmt = formatAmount(Math.abs(n));
  return `${signo}${SIMBOLOS[moneda]}${absFmt}`;
}
